import Swiper, { EffectCreative, Keyboard, SwiperOptions, Pagination, Navigation, Scrollbar } from "swiper";
export const zeroPad = (num: number, places: number) => String(num).padStart(places, '0')


const heroSliders = document.querySelectorAll<HTMLElement>(".g-grader-slider")

heroSliders.forEach(slider => {

  const swiperSettings: SwiperOptions = {
    modules: [Keyboard, EffectCreative, Pagination, Navigation, Scrollbar],
    slidesPerView: 1.5,
    spaceBetween: -1,
    allowTouchMove: false,
    cssMode: true,
    keyboard: {
      enabled: true,
    },
    scrollbar: {
      el: slider.closest(".g-grader__content")?.querySelector<HTMLElement>(".swiper-scrollbar"),
      draggable: true,

    },
    navigation: {
      nextEl: slider.closest(".g-grader__content")?.querySelector<HTMLElement>(".swiper-button-next"),
      prevEl: slider.closest(".g-grader__content")?.querySelector<HTMLElement>(".swiper-button-prev"),
    },
    breakpoints: {
      576: {
        slidesPerView: 2,
        cssMode: false,
      },
      992: {
        slidesPerView: 3,
        cssMode: false,
      },
    },
    on: {
      init: () => {
        slider.classList.remove("--loading")
      },
    }
  }

  new Swiper(slider, swiperSettings)

})
